import { useAuth } from "@/contexts/AuthContext";
import CommunityScience from "@/components/CommunityScience";
import LiveWeatherWidget from "@/components/LiveWeatherWidget";
import EnvironmentalIndicators from "@/components/EnvironmentalIndicators";
import ReadingList from "@/components/ReadingList";
import DigestPreview from "@/components/DigestPreview";
import NatureDiaryPanel from "@/pages/NatureDiaryPanel";

export default function Dashboard() {
  const { user } = useAuth();
  return (
    <>
      <section className="pt-32 pb-16 px-6 md:px-10 max-w-[1600px] mx-auto">
        <div className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-brand)] mb-4">/ Dashboard · Signed in</div>
        <h1 className="font-serif-display text-6xl md:text-8xl leading-[0.9] tracking-tighter">Welcome, {user?.name?.split(" ")[0] || "witness"}.</h1>
        <p className="mt-6 max-w-2xl text-[color:var(--np-text-2)] text-lg">
          Your observations become part of the permanent archive. Your bookmarked stories live here. Curate the weekly digest, and let the record grow.
        </p>
        <div className="mt-12 max-w-2xl">
          <LiveWeatherWidget />
        </div>
      </section>
      <NatureDiaryPanel />
      <ReadingList />
      <DigestPreview />
      <EnvironmentalIndicators />
      <CommunityScience />
    </>
  );
}
